import React from 'react';
import PropTypes from 'prop-types';

function SquareButton({ active, activeColor, background, border, color }) {
  return (
    <>
      {background && (
        <path
          d="M581.958 267.179C595.155 267.179 605.854 256.48 605.854 243.282C605.854 230.085 595.155 219.386 581.958 219.386C568.76 219.386 558.061 230.085 558.061 243.282C558.061 256.48 568.76 267.179 581.958 267.179Z"
          fill={background}
        />
      )}
      <path
        d="M581.958 267.179C595.155 267.179 605.854 256.48 605.854 243.282C605.854 230.085 595.155 219.386 581.958 219.386C568.76 219.386 558.061 230.085 558.061 243.282C558.061 256.48 568.76 267.179 581.958 267.179Z"
        fill={activeColor}
        fillOpacity={active ? 1 : 0}
      />
      <path
        d="M568.022 229.378V231.08V257.218H595.862V229.378H568.022ZM571.438 232.794H592.446V253.802H571.438V232.794Z"
        fill={color}
      />
      <path
        d="M606.741 243.3C606.741 229.628 595.613 218.503 581.942 218.503C568.27 218.503 557.144 229.628 557.144 243.3C557.144 256.972 568.27 268.092 581.942 268.092C595.613 268.092 606.741 256.972 606.741 243.3ZM602.854 243.3C602.854 254.873 593.514 264.209 581.942 264.209C570.369 264.209 561.027 254.873 561.027 243.3C561.027 231.728 570.369 222.386 581.942 222.386C593.514 222.386 602.854 231.728 602.854 243.3Z"
        fill={border}
      />
    </>
  );
}

SquareButton.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  background: PropTypes.string,
  border: PropTypes.string,
  color: PropTypes.string,
};

SquareButton.defaultProps = {
  active: false,
  activeColor: '#FF0000',
  background: null,
  border: '#6F727C',
  color: '#AEAFB6',
};

export default SquareButton;
